var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 375",
    height: 45,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "648fa3d3de"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 71.722656 30.058594 L 303.472656 30.058594 L 303.472656 327.058594 L 71.722656 327.058594 Z M 71.722656 30.058594 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#648fa3d3de)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8304b4",
    d: "M 303.273438 230.78125 L 228.8125 187.796875 L 219.878906 192.9375 L 136.519531 241.058594 L 136.519531 327.054688 L 219.878906 278.902344 Z M 207.222656 95.792969 L 136.519531 136.625 L 130.0625 140.351562 L 71.722656 174.015625 L 103.171875 192.199219 L 146.1875 217.03125 L 213.421875 178.191406 L 219.878906 174.46875 L 303.273438 126.3125 L 228.8125 83.332031 L 219.878906 78.191406 L 213.839844 74.6875 L 136.519531 30.070312 L 136.519531 119.339844 L 192.285156 87.152344 Z M 207.222656 95.792969 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7d0710e8745a7d8bd1854c9a462ee0b7.svg";
export { ForwardRef as ReactComponent };